<template>
  <div :class="$attrs.class">
    <component
      :is="form.Field"
      :name="name"
      :class="$attrs.class"
      :validators="validators"
    >
      <template #default="formProps">
        <FormInput
          :id="id"
          ref="inputRef"
          :model-value="formProps.field.state.value"
          :label="label"
          :type="type"
          :disabled="disabled"
          :required="required"
          :autocomplete="autocomplete"
          :data-test-id="dataTestId"
          :placeholder="placeholder"
          @update:model-value="(value) => formProps.field.handleChange(value)"
          @blur="formProps.field.handleBlur"
          @focus="formProps.field.handleFocus"
          @change="
            (event) =>
              formProps.field.handleChange(
                (event.target as HTMLInputElement).value
              )
          "
        >
          <template #error>
            {{ error(formProps) }}
          </template>
        </FormInput>
      </template>
    </component>
  </div>
</template>

<script setup lang="ts">
import type { z } from 'zod'
import FormInput from '~/components/common/form/FormInput.vue'

defineProps<{
  form: any // The form instance from @tanstack/vue-form
  name: string
  label?: string
  type?: string
  disabled?: boolean
  required?: boolean
  id?: string
  autocomplete?: string
  dataTestId?: string
  placeholder?: string
  validators?: Record<string, z.ZodType<any>>
}>()

const inputRef = ref<InstanceType<typeof FormInput> | null>(null)

const error = (formProps: any) => {
  if (!formProps.field.state.meta) return undefined
  return formProps.field.state.meta.isTouched
    ? formProps.field.state.meta.errors?.[0]?.message
    : undefined
}

defineExpose({
  inputRef,
  focusInput: () => {
    if (inputRef.value) {
      inputRef.value.focusInput()
    }
  },
})
</script>
